import { useGLTF } from '@react-three/drei'

import type { UseGLTFResult } from '../../@types/react-three-fiber-gltf'

export const useGLTFLoader = (modelLocation: string): UseGLTFResult => {
    // gltf loader is insufficiently typed, cast to unknown then extend type.
    const model = useGLTF(modelLocation) as unknown as UseGLTFResult

    return model
}

export const preloadGLTF = useGLTF.preload
